export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  avatarInitials: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quote: "I was managing 12 clients on Fiverr and Upwork, and I kept missing deadlines because I couldn't keep track of everything. I tried using Google Sheets but it was a mess. FiverFlow changed everything - I can see all my orders, deadlines, and client info in one place. Last month I didn't miss a single deadline.",
    name: "Sarah Chen",
    role: "UI/UX Designer • 3 years freelancing",
    avatarInitials: "SC"
  },
  {
    quote: "Creating invoices used to take me 20-30 minutes each because I had to format everything manually in Word. With FiverFlow's templates, I can generate a professional invoice in under 2 minutes. My clients appreciate the clean design, and I've noticed I'm getting paid about 3-5 days faster on average.",
    name: "Marcus Rodriguez",
    role: "Full-Stack Developer • Upwork Top Rated",
    avatarInitials: "MR"
  },
  {
    quote: "I run a small e-commerce business selling custom products through TikTok Shop. Before FiverFlow, I lost track of orders constantly - I'd have to dig through DMs and emails to find what someone ordered. Now everything is organized by client, and I can see order status at a glance. It's saved me probably 5-6 hours per week.",
    name: "Emma Thompson",
    role: "E-commerce Seller • 200+ orders/month",
    avatarInitials: "ET"
  },
  {
    quote: "The analytics feature was eye-opening. I realized I was spending 40% of my time on projects that only generated 15% of my revenue. After focusing on higher-value clients, my monthly income increased from $3,200 to $5,800 in about 4 months. The data doesn't lie.",
    name: "James Park",
    role: "Brand Strategist • Independent Consultant",
    avatarInitials: "JP"
  },
  {
    quote: "Managing 8 social media clients meant juggling multiple tools - one for scheduling, another for analytics, spreadsheets for client info. FiverFlow consolidated most of that. The client notes feature is especially helpful - I can quickly see what we discussed last time without scrolling through old messages.",
    name: "Lisa Wang",
    role: "Social Media Manager • 8 active clients",
    avatarInitials: "LW"
  },
  {
    quote: "I'll be honest, I'm not great with new software. But FiverFlow's interface is intuitive - I figured out the basics in about 30 minutes. The calendar feature prevents me from double-booking, which happened twice before I started using it. That alone makes it worth it.",
    name: "David Kim",
    role: "Web Developer • Freelancing since 2021",
    avatarInitials: "DK"
  },
  {
    quote: "Most of my clients come through Instagram DMs, which made tracking conversations and orders really difficult. I'd forget who ordered what, when it was due, what they paid. FiverFlow lets me add all that info and set reminders. It's like having a second brain for my business.",
    name: "Alex Rivera",
    role: "Content Creator • 15K Instagram followers",
    avatarInitials: "AR"
  },
  {
    quote: "I was skeptical about the AI assistant at first - thought it would be a gimmick. But Jett actually helps me write clearer client messages and suggests action items I might have missed. It's not perfect, but it saves me time on admin tasks so I can focus on the actual work.",
    name: "Sophie Martin",
    role: "Copywriter • Fiverr Level 2 Seller",
    avatarInitials: "SM"
  },
  {
    quote: "I used to forget to send invoices regularly, which meant delayed payments. With FiverFlow, I set reminders and can see at a glance who hasn't paid yet. My payment collection rate improved from about 75% on-time to 92% on-time. That's real money in my pocket.",
    name: "Ryan O'Connor",
    role: "Video Editor • 50+ projects completed",
    avatarInitials: "RO"
  },
  {
    quote: "I tried a few other project management tools but they were too complicated or expensive. FiverFlow strikes the right balance - it has what I need without being overwhelming. The dashboard is clean, and I can find things quickly. Been using it for 6 months now.",
    name: "Maria Santos",
    role: "Graphic Designer • Fiverr Pro Seller",
    avatarInitials: "MS"
  },
  {
    quote: "The workboard feature helps me break down complex projects into manageable tasks. I can set priorities, track progress, and see what's due this week. My clients notice I'm more organized and responsive. It's made me a better freelancer, honestly.",
    name: "Chris Johnson",
    role: "Marketing Consultant • $50K+ annual revenue",
    avatarInitials: "CJ"
  },
  {
    quote: "I've been freelancing for 6 years and tried probably 10 different tools. Most were either too simple or too complex. FiverFlow gets it right - it handles the complexity of managing multiple clients and platforms without being overwhelming. The fact that it tracks orders from Fiverr, Upwork, and direct clients in one place is huge.",
    name: "Priya Patel",
    role: "SEO Specialist • Multi-platform freelancer",
    avatarInitials: "PP"
  },
  {
    quote: "The client management section is what sold me. I can see a client's full history - all past orders, notes from our conversations, payment history. When a repeat client messages me, I can quickly refresh my memory about previous work. It makes me look more professional and organized.",
    name: "Michael Torres",
    role: "Logo Designer • 100+ clients served",
    avatarInitials: "MT"
  },
  {
    quote: "I was spending too much time on administrative tasks instead of actual design work. FiverFlow automated a lot of that - invoice generation, payment tracking, deadline reminders. I estimate it saves me 8-10 hours per month, which I can now spend on taking on more projects or improving my skills.",
    name: "Jessica Lee",
    role: "Brand Designer • Independent",
    avatarInitials: "JL"
  },
  {
    quote: "The mobile responsiveness is great. I can check my orders and client info on my phone when I'm away from my desk. It's not as full-featured as the desktop version, but it's enough for quick checks and updates. That flexibility is important when you're always on the go.",
    name: "Kevin Brown",
    role: "Photographer • Travel Freelancer",
    avatarInitials: "KB"
  }
];

